import * as actionTypes from '../constants/actionTypes';
export function startReplay(events, startPosition) {
    return {
        type: actionTypes.REPLAY_START_PLAYING,
        events: events,
        startPosition: startPosition,
    };
}
export function seekReplay(events, startPosition) {
    return {
        type: actionTypes.REPLAY_SEEK,
        events: events,
        startPosition: startPosition,
    };
}
export function pauseReplay() {
    return {
        type: actionTypes.REPLAY_STOP_PLAYING,
    };
}
export function startRecording(_a) {
    var _b = _a === void 0 ? {} : _a, goalScreenPk = _b.goalScreenPk;
    return {
        type: actionTypes.REPLAY_START_RECORDING,
        goalScreenPk: goalScreenPk,
    };
}
export function stopRecording() {
    return {
        type: actionTypes.REPLAY_STOP_RECORDING,
    };
}
export function progress(played) {
    return {
        type: actionTypes.REPLAY_PROGRESS,
        played: played,
    };
}
export function onEvent(event, eventIndex) {
    return {
        type: actionTypes.REPLAY_ON_EVENT,
        event: event,
        eventIndex: eventIndex,
    };
}
